import { render } from "./TeacherTeam.vue?vue&type=template&id=4d3d3bc4&scoped=true"
import script from "./TeacherTeam.vue?vue&type=script&lang=js"
export * from "./TeacherTeam.vue?vue&type=script&lang=js"

import "./TeacherTeam.vue?vue&type=style&index=0&id=4d3d3bc4&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3d3bc4"]])

export default __exports__